import { Series } from 'highcharts';
import { Periodicity } from '@components/time-period-selector/PeriodsTypes';
import { BaseChartResp } from '../share-comparison-chart/Types';
import { GrowthTypes } from '../performance-segment-chart/Types';
import { isKpiShare } from '@utils/TableUtils';
import { ValueType } from '@utils/Formatters';

export interface TooltipSeriesPoint extends Series {
  color?: string;
}

export const buildXAxisLabel = (data: BaseChartResp[], selectedPeriodicity: Periodicity) => {
  return data.map((d: any) => {
    // e.g. W11-20
    if (selectedPeriodicity === Periodicity.Weekly && d.period.includes('-')) {
      // [W11, 20]
      const periods = d.period.split('-');

      // Output: Week 11, 2020
      return `${periods[0].slice(0, 1)}eek ${periods[0].slice(1, 3)}, 20${periods[1]}`;
    }
    return d.period.charAt(0) + d.period.slice(1).toLowerCase();
  });
};

export const buildDataForSeries = (data: BaseChartResp[]) => {
  return data.map((d: BaseChartResp) => {
    return d.value;
  });
};

// Display `pp` if kpi is share, `%` for percentage compare type, and actual
// value for actual compare type eg. +123pp, +100%
export const displayOption = (kpiKey: any, selectedGrowthType: GrowthTypes) => {
  if (isKpiShare(kpiKey)) {
    return ValueType.ABSOLUTE_CHANGE;
  } else if (selectedGrowthType === GrowthTypes.percentage) {
    return ValueType.PERCENTAGE_CHANGE;
  } else {
    return ValueType.ABSOLUTE_CHANGE;
  }
};

export const chartOption = {
  title: {
    text: '',
  },
  credits: {
    enabled: false,
  },
  plotOptions: {
    line: {
      lineWidth: 2,
      marker: {
        enabled: true,
        radius: 3,
      },
    },
  },
};
